import styled from '@emotion/styled';
import { Box, Pagination } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useCallback, useEffect, useRef, useState } from 'react';
import dataGridLocalText from 'utils/js/dataGridLocalText';
import { escapeRegExp, rowDataSearchFilter } from 'utils/js/private/tableUtils';

import { QuickSearchToolbar } from './QuickSearchToolbar/QuickSearchToolbar';
import {
  ApiTableCustomFooter,
  TableCustomFooter,
} from './TableCustomFooter/TableCustomFooter';
import { TableCustomApiPagination } from './TableCustomPagination/TableCustomPagination';

const Table = props => {
  const {
    columns,
    rowsData = [],
    rows = [],
    customToolbar,
    disableSelection,
    isDeletable,
    isLoading,
    addLable,
    onAddClick,
    apiRef,
    onPageChange,
    page,
    countPages,
    handleSearchApi,
    pageSize,
    setPageSize,
    setSelectedRows,
    selectedRows,
    disableSelectAll,
  } = props;

  const [searchText, setSearchText] = useState('');

  const [selectionModel, setSelectionModel] = useState([]);

  useEffect(() => {
    if (selectedRows) {
      setSelectionModel(selectedRows);
    }
  }, [selectedRows]);

  const requestSearch = e => {
    setSearchText(e.target.value);
  };

  const onScroll = useCallback(
    event => {
      const x = apiRef.current?.getScrollPosition().left;
      apiRef.current.columnHeadersContainerElementRef.current.scrollLeft = x;
    },
    [apiRef?.current, apiRef],
  );

  useEffect(() => {
    setTimeout(() => {
      apiRef.current?.windowRef?.current?.removeEventListener(
        'scroll',
        onScroll,
      );
      apiRef.current?.windowRef?.current?.addEventListener('scroll', onScroll);
    }, 0);
    return () => {
      apiRef?.current?.windowRef?.current?.removeEventListener(
        'scroll',
        onScroll,
      );
    };
  }, [apiRef.current, onScroll, columns.length]);

  function handleClearText() {
    setSearchText('');
  }

  function handleSearch() {
    handleSearchApi(searchText);
  }

  return (
    <Container>
      <DataGrid
        loading={isLoading}
        localeText={dataGridLocalText}
        rows={rows}
        rowCount={rows?.length}
        pageSize={pageSize}
        columns={columns}
        density="standard"
        disableVirtualization
        checkboxSelection={!disableSelection}
        isRowSelectable={() => !isLoading}
        onSelectionModelChange={newSelectionModel => {
          if (isLoading) return;
          setSelectionModel(newSelectionModel);
          setSelectedRows?.(newSelectionModel);
        }}
        selectionModel={selectionModel}
        disableSelectionOnClick
        autoHeight
        onPageSizeChange={newPageSize => setPageSize(newPageSize)}
        sx={
          disableSelectAll
            ? {
                '& .MuiDataGrid-columnHeaderCheckbox': {
                  display: 'none',
                },
              }
            : undefined
        }
        components={{
          Toolbar: customToolbar ?? QuickSearchToolbar,
          Pagination: TableCustomApiPagination,
          Footer: ApiTableCustomFooter,
        }}
        componentsProps={{
          toolbar: {
            value: searchText,
            onChange: event => requestSearch(event),
            onSearchSubmit: handleSearch,
            clearSearch: () => handleClearText(),
            addLable,
            onAddClick,
          },
          footer: {
            page,
            countPages,
            onPageChange,
            rowsCount: selectionModel.length,
            pageSize,
            // isDeletable,
            setPageSize: value => setPageSize(value),
          },
        }}
      />
    </Container>
  );
};

const Container = styled(Box)`
  ${({ theme }) => ({
    'width': '100%',
    '& *': {
      direction: 'rtl',
    },
    '& .MuiDataGrid-columnHeaders': {
      backgroundColor: theme.palette.brand.blue.primary,
      color: theme.palette.primary.contrastText,
    },
  })}
`;

export default Table;
